module.exports = __webpack_public_path__ + "img/icon-cashback-statistic.fa027426.svg";